import axios from 'axios';
import { initialize, destroy } from 'redux-form';

import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import types from './types';

const URL = `${BASE_API}/cupoms/`;
const URL_ACTION = `${BASE_API}/actions`;

export const submitAction = (
  actionValues,
  router = undefined,
  create_or_update,
  id = undefined,
  publishAction
) => {
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);

    if (create_or_update === 'create') {
      axios
        .post(`${URL_ACTION}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
          onUploadProgress: (progressEvent) =>
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
              },
            ]),
        })
        .then((actionResponse) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            {
              type: 'SUBMIT_PROGRESS',
              payload: 0,
            },
            {
              type: 'SNACKBAR',
              payload: {
                message: 'Operação realizada com sucesso',
                variant: 'success',
                open: true,
              },
            },
            destroyForm(),
          ]);
          router.push('/owner');
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            {
              type: 'SUBMIT_PROGRESS',
              payload: 0,
            },
          ]);
          try {
            if (e.response.data.error) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data.error}`,
                  variant: 'error',
                  open: true,
                },
              });
            } else {
              try {
                for (const i in e.response.data) {
                  dispatch({
                    type: 'SNACKBAR',
                    payload: {
                      message: `${e.response.data[i]}`,
                      variant: 'error',
                      open: true,
                    },
                  });
                }
              } catch (error) {
                dispatch({
                  type: 'SNACKBAR',
                  payload: { message: 'Erro', variant: 'error', open: true },
                });
              }
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    } else if (create_or_update === 'update') {
      axios
        .put(`${URL_ACTION}/${id}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        })
        .then((actionResponse) => {
          if (publishAction) {
            dispatch([publishAction()]); // dispatch só pra retornar na função
          } else {
            dispatch([
              destroyForm(),
              { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
              {
                type: 'SUBMIT_PROGRESS',
                payload: 0,
              },
            ]);
            if (router) {
              router.push('/owner/acoes/minhas-atividades');
            }
          }
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            {
              type: 'SUBMIT_PROGRESS',
              payload: 0,
            },
          ]);
          try {
            if (e.response.data.error) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data.error}`,
                  variant: 'error',
                  open: true,
                },
              });
            } else {
              try {
                for (const i in e.response.data) {
                  dispatch({
                    type: 'SNACKBAR',
                    payload: {
                      message: `${e.response.data[i]}`,
                      variant: 'error',
                      open: true,
                    },
                  });
                }
              } catch (error) {
                dispatch({
                  type: 'SNACKBAR',
                  payload: { message: 'Erro', variant: 'error', open: true },
                });
              }
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    }
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    dispatch({
      type: types.LIST_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_ACTION}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const categories = response.data.category_actions.map((item) => ({
          id: item.category?.id,
          title: item.category?.name,
        }));

        const groupings = response.data.action_grouping.map((item) => ({
          id: item.grouping?.id,
          title: item.grouping?.name,
        }));

        const { target } = response.data;

        let videosPlaylist = [];
        if (response.data.action_videos.length > 0) {
          videosPlaylist = response.data.action_videos.map((item, index) => {
            return {
              name: item.name,
              description: item.description,
              id: item.video_id,
              viewed: false,
              required: item.required,
              url: item.video.url,
            };
          });
        }

        const initialValues = {
          ...response.data,
          categories_field: categories,
          groupings_field: groupings,
          from: target.age ? target.age.from : null,
          to: target.age ? target.age.to : null,
          states: target.states,
          entities: target.entities,
          associated: target.associated,
          rules: response.data.rules,
          internal: target.internal,
          segmentation_type: target.segment_users ? 'users' : 'public',
          segment_users: target.segment_users || [],
          videosIds:
            response.data.action_videos.length > 0
              ? response.data.action_videos.map((video, index) => video.video_id)
              : [],
          videosAdd: videosPlaylist,
          has_giveaway: response.data.giveaway_number_rules.length > 0,
          giveaway_quantity:
            response.data.giveaway_number_rules.length > 0
              ? response.data.giveaway_number_rules[0].quantity
              : null,
          giveaway_id:
            response.data.giveaway_number_rules.length > 0
              ? response.data.giveaway_number_rules[0].giveaway_id
              : null,
          isThereTrophy: !!response.data.trophy_description,
        };

        if (parseFloat(initialValues.price) > 0 || parseFloat(initialValues.discount_price) > 0) {
          initialValues.discountPrice = initialValues.price - initialValues.discount_price;
          initialValues.prices = true;
        } else {
          initialValues.prices = false;
        }
        dispatch([
          initializeForm(initialValues),
          {
            type: types.DETAIL_FETCHED,
            payload: response.data[0],
          },
        ]);
      });
  };
};

export const initializeForm = (values) => {
  return initialize('videoPlaylistForm', values);
};

export const create = (values, router, firstTime) => {
  return submit(values, 'post', router, firstTime);
};

export const update = (values, router) => {
  return submit(values, 'put', router);
};

export const destroyForm = () => {
  return destroy('videoPlaylistForm');
};

function submit(values, method, router = undefined, firstTime) {
  const id = values.id ? `${values.id}/` : '';
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios[method](`${URL}${id}`, values, {
      headers: {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      },
      onUploadProgress: (progressEvent) =>
        dispatch([
          {
            type: 'SUBMIT_PROGRESS',
            payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
          },
        ]),
    })
      .then((response) => {
        /* dispatch([reset(), getList()]); */
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
        ]);

        if (!_.isUndefined(router)) {
          if (firstTime) {
            router.push('/owner');
          } else {
            router.push('/owner/cupons');
          }
        }
      })
      .catch((e) => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
        ]);

        try {
          for (const i in e.response.data) {
            for (const j in e.response.data[i]) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${i}: ${e.response.data.errors[i][j]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
}

export const dispatchFormReset = () => {
  return (dispatch) => {
    dispatch(destroy('videoPlaylistForm'));
  };
};

export const savePartialy = (values, router, setValue, value) => {
  const { id } = router.params;
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios
      .put(`${URL_ACTION}/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        onUploadProgress: (progressEvent) =>
          dispatch([
            {
              type: 'SUBMIT_PROGRESS',
              payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
            },
          ]),
      })
      .then((response) => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
          setValue(value + 1),
        ]);
      })
      .catch((e) => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
        ]);

        try {
          for (const i in e.response.data) {
            for (const j in e.response.data[i]) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${i}: ${e.response.data.errors[i][j]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};
